export const LINK_ADDRESS_RULE =
  'Enter an address that starts with https://, http:// or mailto:, or a path that starts with /.';

/**
 * The address a link may have, or null: a web page, an email address, or a
 * path on this site. Anything else, a `javascript:` address above all, is
 * refused.
 */
export function readLinkAddress(value: string): string | null {
  const address = value.trim();

  if (address.length === 0 || /\s/.test(address)) {
    return null;
  }

  // A path on this site. Not "//", which leaves for another host.
  if (address.startsWith('/')) {
    return address.startsWith('//') ? null : address;
  }

  let url: URL;

  try {
    url = new URL(address);
  } catch {
    return null;
  }

  if (url.protocol === 'mailto:') {
    return url.pathname.length > 0 ? address : null;
  }

  if (url.protocol === 'http:' || url.protocol === 'https:') {
    return url.hostname.length > 0 ? address : null;
  }

  return null;
}
